import * as React from 'react';
import { Context } from './Context';

export interface BuiltLink {
	isRelative: boolean;
	to: string;
}

type Redirect = (to: string, subdomain?: string | null, replace?: boolean, data?: unknown) => void;

export const useRouter = (): [Redirect, (to: string, subdomain?: string | null) => BuiltLink] => {
	const { subdomain: currentSubdomain, host, protocol } = React.useContext(Context);

	const buildLink = (to: string, subdomain?: string | null): BuiltLink =>
		subdomain === undefined || subdomain === currentSubdomain
			? { isRelative: true, to }
			: {
					isRelative: false,
					to: `${protocol}//${subdomain !== null ? `${encodeURIComponent(subdomain)}.` : ''}${host}${to}`,
			  };

	const redirect: Redirect = (to, subdomain, replace, data) => {
		const link = buildLink(to, subdomain);
		if (link.isRelative) {
			if (replace ?? false) {
				history.replaceState(data, '', link.to);
			} else {
				history.pushState(data, '', link.to);
			}
		} else {
			window.location.assign(link.to);
		}
	};

	return [redirect, buildLink];
};
